/**
 * The power-down tick box, wherever it is asked for.
 *
 * Two screens ask the same question. The programming screen carries it
 * alongside the program, which is where the answer is normally given: it
 * rides along with the submission and the server parks it, so the engine's
 * own Announce Power Down phase resolves itself and is never seen.
 *
 * The exception is a turn whose program was forced through -- a dropped
 * player, or a host unsticking the table -- where nothing was parked
 * because nobody filled the screen in. The phase then waits, and the
 * question has to be asked on its own.
 *
 * One definition rather than two, so the wording and the control cannot
 * drift between them. It used to be a pair of buttons in the second place
 * and a checkbox in the first, which read as two different decisions.
 */
export function PowerDownChoice(
  { value, onChange, disabled = false }:
  {
    value: boolean;
    onChange: (value: boolean) => void;
    /** True while a submission is in flight, or once one is final. */
    disabled?: boolean;
  },
) {
  return (
    <label className="powerdown">
      <input
        type="checkbox"
        checked={value}
        disabled={disabled}
        onChange={(e) => onChange(e.target.checked)}
      />
      <span>
        Power down next turn
        <span className="muted"> - take no actions and discard all damage</span>
      </span>
    </label>
  );
}
